<template>
	<b-container fluid>
		<b-modal ref="addPayment" hide-footer title="Dodaj wpłatę">
			<alert-loading v-if="paymentLoading"></alert-loading>
			<form-payment v-if="selectedInvoice && !paymentLoading" ref="addPaymentForm" :currencyName="invoiceCurrency"
						  :handleSubmit="handlePayment"
						  :values="paymentData" :errors="paymentViolations"></form-payment>
			<b-row v-if="!paymentLoading">
				<b-col>
					<b-button class="mt-3" variant="primary" block @click="hideAddPaymentModal"><span>Anuluj</span>
						<svg-icon name="back"/>
					</b-button>
				</b-col>
				<b-col>
					<b-button class="mt-3" variant="default" block @click="sendPaymentForm"><span>Zapisz</span>
						<svg-icon name="tick"/>
					</b-button>
				</b-col>
			</b-row>
		</b-modal>

		<page-title><h2><router-link :to="{ name: 'FactoredInvoiceList' }" class="nav-link">Faktury zakupione</router-link></h2></page-title>

		<b-container class="col page-element">
			<alert-loading v-if="loading"></alert-loading>
			<div v-if="createdPaymentMessage" class="alert alert-success">Płatność w kwocie {{createdPaymentMessage}} została dodana</div>
			<div v-if="deletedItem" class="alert alert-success">{{ deletedItem['@id'] }} deleted.</div>
			<div v-if="error" class="alert alert-danger">{{ error }}</div>

			<div v-if="!loading">
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-hover table-clickable table-search">
						<thead>
							<tr>
								<td><b-form-input type="text" class="form-control input-search" v-model="filter.number" /><svg-icon name="search" /></td>
								<td><date-range-picker v-model="selectedCreateDatePeriod" pickerClass="two-rows"></date-range-picker></td>
								<td><date-range-picker v-model="selectedPaymentDatePeriod" pickerClass="two-rows"></date-range-picker></td>
								<td><b-form-input type="text" class="form-control input-search" v-model="filter.debtor"/><svg-icon name="search" /></td>
								<td><b-form-input type="text" class="form-control input-search" v-model="filter['agreement.fullNumber']"/><svg-icon name="search" /></td>
								<td></td>
								<td></td>
								<td><dropdown-search id="status-dropdown" :elements="currencyTypes" v-model="filter['agreement.currency']" nameField="name" :showEmpty="true" valueField="id"/></td>
								<td><dropdown-search id="status-dropdown" :elements="statusLists" v-model="selectedStatus" :showEmpty="true" nameField="name" valueField="value" /></td>
								<td class="no-wrap" ><my-button variant="info" :action="getItems"/> <my-button icon="back" variant="primary" :action="resetFilter"/></td>
							</tr>
							<tr>
								<th v-on:click="setOrder('number')" class="sorting" :class="getOrder('number')">Numer</th>
								<th v-on:click="setOrder('createDate')" class="sorting" :class="getOrder('createDate')">Data wystawienia</th>
								<th v-on:click="setOrder('paymentDate')" class="sorting" :class="getOrder('paymentDate')">Termin zapłaty</th>
								<th v-on:click="setOrder('debtorData.name')" class="sorting" :class="getOrder('debtorData.name')">Dłużnik</th>
								<th v-on:click="setOrder('agreement.fullNumber')" class="sorting" :class="getOrder('agreement.fullNumber')">Umowa</th>
								<th v-on:click="setOrder('amount')" class="sorting" :class="getOrder('amount')">Kwota</th>
								<th v-on:click="setOrder('leftToPaid')" class="sorting" :class="getOrder('leftToPaid')">Do zapłaty</th>
								<th v-on:click="setOrder('agreement.currency.name')" class="sorting" :class="getOrder('agreement.currency.name')">Waluta</th>
								<th>Status</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in items">
								<td><router-link :to="{name: 'AgreementUpdate', params: { id: item.agreement.id, tab: 'invoice' }}">{{ item['number'] }}</router-link></td>
								<td><router-link :to="{name: 'AgreementUpdate', params: { id: item.agreement.id, tab: 'invoice' }}">{{ item['createDate'] | date }}</router-link></td>
								<td><router-link :to="{name: 'AgreementUpdate', params: { id: item.agreement.id, tab: 'invoice' }}">{{ item['paymentDate'] | date }}</router-link></td>
								<td><router-link :to="{name: 'AgreementUpdate', params: { id: item.agreement.id, tab: 'invoice' }}">{{ item['debtorData']['name'] }}, NIP:&nbsp;{{ item['debtorData']['nip'] }}</router-link></td>
								<td><router-link :to="{name: 'AgreementUpdate', params: { id: item.agreement.id, tab: 'invoice' }}">{{ item['agreement']['fullNumber'] }}</router-link></td>
								<td><router-link :to="{name: 'AgreementUpdate', params: { id: item.agreement.id, tab: 'invoice' }}">{{ item['amount'] }}</router-link></td>
								<td><router-link :to="{name: 'AgreementUpdate', params: { id: item.agreement.id, tab: 'invoice' }}">{{ item['leftToPaid']}}</router-link></td>
								<td><router-link :to="{name: 'AgreementUpdate', params: { id: item.agreement.id, tab: 'invoice' }}">{{ item['agreement']['currency']['name'] }}</router-link></td>
								<td>
									<router-link :to="{name: 'AgreementUpdate', params: { id: item.agreement.id, tab: 'invoice' }}">
										<span v-if="item['paid']" class="element_status closed">Zapłacona</span>
										<span v-if="!item['paid'] && !item['deducted']" class="element_status open">Niezapłacona</span>
										<span v-if="item['deducted']" class="element_status deducted">Potrącona</span>
										<span v-if="item['returned']" class="element_status returned">Zwrócona</span>
									</router-link>
                				</td>
								<td>
									<!--<a href="#" v-b-tooltip.hover.bottom title="Dodaj wpłatę"-->
									   <!--class="btn btn-icon btn-icon&#45;&#45;success" @click.prevent="addPayment(item)">-->
										<!--<svg-icon name="confirm"/>-->
									<!--</a>-->
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<pagination :changePage="changePage" :currentPage="currentPage" :pagination="pagination"></pagination>
			</div>

		</b-container>
	</b-container fluid>
</template>

<script>
	import {mapActions, mapGetters} from 'vuex';
	import sort from '../../utils/order';
	import moment from 'moment';
	import FormPayment from '../agreement/FormPayment.vue'

	export default {
    data: function() {
      return {
        selectedInvoice: null,
        createdPaymentMessage: null,
        selectedCreateDatePeriod: null,
        selectedPaymentDatePeriod: null,
        selectedStatus: null,
        paymentData: {},
        statusLists:[
          {value:'paid', name: 'Zapłacona'},
          {value:'notPaid', name: 'Niezapłacona'},
          {value:'deducted', name: 'Potrącona'},
          {value:'returned', name: 'Zwrócona'},
        ]
      };
    },
    components: {
      'form-payment': FormPayment
    },
    computed: {
      invoiceCurrency () {
        return this.selectedInvoice ? this.selectedInvoice.agreement.currency.name : '...'
      },
      ...mapGetters({
        deletedItem: 'factoredinvoice/del/deleted',
        error: 'factoredinvoice/list/error',
        items: 'factoredinvoice/list/items',
        loading: 'factoredinvoice/list/loading',
        currentPage: 'factoredinvoice/list/currentPage',
        pagination: 'factoredinvoice/list/pagination',
        order: 'factoredinvoice/list/order',
        filter: 'factoredinvoice/list/filter',
        currencyTypes: 'config/config/currencyTypes',
        agreementStatus: 'config/config/agreementStatus',
        paymentLoading: 'payment/create/loading',
        paymentCreated: 'payment/create/created',
        paymentViolations: 'payment/create/violations'
    })},
    methods: {
		resetFilter(){
          for (var key in this.filter ){
            this.filter[key] = undefined;
		  }
          this.selectedCreateDatePeriod = null;
		  this.selectedPaymentDatePeriod = null;
		  this.getItems();
		},
        handlePayment (payment) {
          payment.factoredInvoice = this.selectedInvoice['@id']
          this.paymentData = payment
          this.$store.dispatch('payment/create/create', payment)
        },
        addPayment (invoice) {
          this.$store.dispatch('payment/create/reset')
          this.selectedInvoice = invoice
          this.paymentData = {
            amount: invoice.leftToPaid,
            paymentDate: new Date()
          }
          this.$refs.addPayment.show()
        },
        sendPaymentForm () {
          this.$refs.addPaymentForm.sendForm()
        },
        hideAddPaymentModal () {
          this.$refs.addPayment.hide()
        },
      	getOrder: function(column) {
			return sort(this.order, column);
		},
		...mapActions({
			getItems: 'factoredinvoice/list/getItems',
			setOrder: 'factoredinvoice/list/order',
			changePage: 'factoredinvoice/list/changePage'
		})
    },
    created () {
      this.$store.dispatch('factoredinvoice/list/getItems')
      if(this.filter.createDate){
        this.selectedCreateDatePeriod = [
          new Date( this.filter.createDate.after),
          new Date( this.filter.createDate.before)
        ]
      }
      if(this.filter.paymentDate){
        this.selectedPaymentDatePeriod = [
          new Date( this.filter.paymentDate.after),
          new Date( this.filter.paymentDate.before)
        ]
      }
      if(this.filter.paid == true){
        this.selectedStatus = 'paid'
	  } else if (this.filter.deducted == true){
        this.selectedStatus = 'deducted'
	  } else if (this.filter.returned == true){
        this.selectedStatus = 'returned'
      } else if(this.filter.paid == false && this.filter.deducted == false){
	    this.selectedStatus = 'notPaid'
	  }
    },
    watch: {
      selectedCreateDatePeriod: function (date) {
        if(date){
          this.filter.createDate = {
            before: moment(date[1]).format('YYYY-MM-DD 23:59:59'),
            after: moment(date[0]).format('YYYY-MM-DD 00:00:00'),
          }
        }else{
          this.filter.createDate = undefined
        }
      },
      selectedPaymentDatePeriod: function (date) {
        if(date){
          this.filter.paymentDate = {
            before: moment(date[1]).format('YYYY-MM-DD 23:59:59'),
            after: moment(date[0]).format('YYYY-MM-DD 00:00:00'),
          }
        }else{
          this.filter.paymentDate = undefined
        }
      },
      selectedStatus: function (data) {
        this.filter.paid = undefined
        this.filter.deducted = undefined
        this.filter.returned = undefined
        if(data == 'paid'){
          this.filter.paid = true
        }else if(data == 'deducted') {
          this.filter.deducted = true
        }else if(data == 'returned') {
          this.filter.returned = true
        }else if(data == 'notPaid') {
          this.filter.deducted = false
          this.filter.paid = false
        }
      },
      paymentCreated: function (payment) {
        if (payment != null) {
          this.hideAddPaymentModal()
          this.createdPaymentMessage = payment.amount
          setTimeout(() => {
            this.createdPaymentMessage = null
          }, 5000)
          this.$store.dispatch('factoredinvoice/list/getItems');
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?6026835d